import styled from 'styled-components'
import { Link } from 'react-router-dom'
import breakpoints from 'utils/consts/breakpoints'
import { hideScrollbar } from 'components/Common/GlobalStyles'

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;

  @media screen and ${breakpoints.device.mobile} {
    flex-direction: column;
    row-gap: 8px;
  }
`

export const ItemLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font: var(--typography-14-20-normal);
  color: var(--color-sw-60);
  width: 160px;
  min-width: 160px;
  margin-right: 24px;
  word-break: break-word;

  @media screen and ${breakpoints.device.mobile} {
    min-width: unset;
    width: unset;
  }
`

export const ItemValue = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: var(--color-night);
  word-break: break-word;
`

export const ChipsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 8px;
  flex: 1;
`

export const ChipsList = styled.div`
  display: flex;
  flex-flow: row wrap;
  flex: 1;
  gap: 8px;
  align-items: flex-start;
  --min-height: ${28 * 2 + 8}px;

  @media screen and ${breakpoints.device.tablet}, ${breakpoints.device.mobile} {
    flex-wrap: nowrap;
    overflow: auto visible;
    scroll-snap-type: x mandatory;
    width: calc(100vw - 208px);
    padding-right: 16px;

    ${hideScrollbar};
  }

  @media screen and ${breakpoints.device.mobile} {
    width: calc(100vw - 32px);
    margin: 0;
    padding: 0;
  }
`

export const ChipsListGrid5 = styled(ChipsList)`
  @media screen and (min-width: ${breakpoints.size.lg}px) {
    display: grid;
    grid-template-columns: repeat(5, auto);
  }
`

export const ChipItem = styled(Link)<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  text-align: center;
  box-sizing: border-box;
  padding: 5px 11px;
  height: 28px;
  border: 1px solid #e7e7ea;
  border-radius: 5px;
  font: var(--typography-14-16-semibold);
  color: #717284;
  white-space: nowrap;
  scroll-snap-align: start;

  ${props => props.selected && 'border-color: #88122B;'}
  :hover {
    border-color: #88122b;
  }
`

export const ChipAddItem = styled(ChipItem)`
  white-space: nowrap;
`

export const ToggleChipList = styled.button`
  appearance: none;
  border: none;
  background: none;
  margin: 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font: var(--typography-14-16-regular);
  color: #3b42a5;
  padding: 6px 0;

  svg {
    min-width: 16px;
  }
`
